import { Box, CardMedia } from '@mui/material';
import React from 'react';

const OwnerBanner = () => (
	<Box>
		<CardMedia
			component="img"
			image="/assets/owner-banner.png"
			alt="Owner Banner"
			sx={{
				width: '100%',
				height: '100%',
				objectFit: 'cover',
				zIndex: 1,
			}}
		/>
	</Box>
);

export default OwnerBanner;
